/** @format */

import React, { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { Icon } from '@king-design/react'
import { useHistory } from 'react-router'
import variable from 'src/static/styles/var'

export interface CustomPageContainerProps {
  className?: string
  /** 页面标题 */
  title?: ReactNode
  /** 是否展示返回按钮 */
  showBack?: boolean
  /** 返回按钮点击回调，未传时默认 history.goBack() */
  onBack?: () => void
  /** 标题栏右侧自定义内容 */
  extra?: ReactNode
  /** 是否展示标题栏，默认 true */
  showHeader?: boolean
  // 标题下内容
  content?: ReactNode
  // 内容
  children?: ReactNode
}

const CustomPageContainer: FC<CustomPageContainerProps> = ({
  className,
  title,
  showBack = false,
  onBack,
  extra,
  showHeader = true,
  content,
  children
}) => {
  const history = useHistory()

  const handleBack = () => {
    if (onBack) {
      onBack()
      return
    }
    history.goBack()
  }

  return (
    <div className={className}>
      {showHeader ? (
        <div className="custom-page-header">
          <div className="custom-page-header-left">
            {showBack ? (
              <button
                type="button"
                className="custom-page-back"
                onClick={handleBack}
                aria-label="back"
              >
                <Icon className="k-icon-left" size={16} />
              </button>
            ) : null}
            <div className="custom-page-title">{title}</div>
          </div>
          {extra ? <div className="custom-page-extra">{extra}</div> : null}
          {content ? <div className="custom-page-content">{content}</div> : null}
        </div>
      ) : null}
      <div className="custom-page-body">{children}</div>
    </div>
  )
}

export default styled(CustomPageContainer)`
  background: #f8f9fa;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 50px);

  .custom-page-header {
    position: sticky;
    top: 50px;
    z-index: 1000;
    width: 100%;
    box-sizing: border-box;
    padding: 16px 24px;
    border-bottom: 1px solid ${variable.borderColor};
    flex-shrink: 0;
    background: #fff;
    min-height: 50px;
    .custom-page-header-left {
      display: flex;
      align-items: center;
      min-width: 0;
      flex: 1;
    }

    .custom-page-back {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      padding: 0;
      margin-right: 4px;
      border: none;
      background: transparent;
      cursor: pointer;
      flex-shrink: 0;

      .k-icon {
        color: ${variable.disableColor};
        transition: color 0.2s;
      }

      &:hover .k-icon {
        color: ${variable.primaryColor};
      }
    }

    .custom-page-title {
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      .k-breadcrumb {
        .k-breadcrumb-item {
          font-size: 14px;
          font-weight: 400;
          line-height: 18px;
        }
      }
    }
  }

  .custom-page-extra {
    position: absolute;
    right: 24px;
    top: 0px;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    margin-left: 16px;
    line-height: 18px;
  }

  .custom-page-content {
    margin-top: 16px;
  }
  .custom-page-body {
    padding: 24px;
    min-width: 0;
  }
`
